import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { FormDataService } from 'src/app/shared/services/formData.service';
import { Guid } from '../../shared/models/guid';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../shared/services/formData.service";
var ProfileService = /** @class */ (function () {
    function ProfileService(http, formDataService) {
        this.http = http;
        this.formDataService = formDataService;
    }
    ProfileService.prototype.get = function (id) {
        var _this = this;
        var requestUrl = baseApiUrl + "/profiles/" + id;
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getChangeHistory = function (profileId) {
        var _this = this;
        var requestUrl = baseApiUrl + "/changehistory/" + profileId;
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.save = function (profile) {
        var _this = this;
        var id = (profile && profile.id) ? profile.id : Guid.empty;
        var requestUrl = baseApiUrl + "/profiles/update/" + id;
        if (profile.isNew == true) {
            requestUrl = baseApiUrl + "/profiles/create";
        }
        var formData = this.formDataService.createFormData(profile);
        return this.http.post(requestUrl, formData).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.saveChangeHistory = function (changeHistory) {
        var _this = this;
        var requestUrl = baseApiUrl + "/changehistory/create";
        return this.http.post(requestUrl, changeHistory).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.saveBusCode = function (busCode) {
        var _this = this;
        var id = (busCode && busCode.id) ? busCode.id : Guid.empty;
        var requestUrl = baseApiUrl + "/bus-codes/update/" + id;
        if (id === Guid.empty)
            requestUrl = baseApiUrl + "/bus-codes/create";
        return this.http.post(requestUrl, busCode).pipe(tap(function (response) { return console.log('Response:', response); }), catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.saveCpdfCode = function (cpdfCode) {
        var _this = this;
        var id = (cpdfCode && cpdfCode.id) ? cpdfCode.id : Guid.empty;
        var requestUrl = baseApiUrl + "/cpdf-codes/update/" + id;
        if (id === Guid.empty)
            requestUrl = baseApiUrl + "/cpdf-codes/create";
        return this.http.post(requestUrl, cpdfCode).pipe(tap(function (response) { return console.log('Response:', response); }), catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.saveUnion = function (union) {
        var _this = this;
        var id = (union && union.id) ? union.id : Guid.empty;
        var requestUrl = baseApiUrl + "/unions/update/" + id;
        if (id === Guid.empty)
            requestUrl = baseApiUrl + "/unions/create";
        return this.http.post(requestUrl, union).pipe(tap(function (response) { return console.log('Response:', response); }), catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.search = function (searchOptions) {
        var _this = this;
        var agencies = searchOptions.filters.agencies.map(function (s) { return "agencies=" + s; }).join("&");
        var unions = searchOptions.filters.unions.map(function (s) { return "unions=" + s; }).join("&");
        var busCodes = searchOptions.filters.busCodes.map(function (s) { return "busCodes=" + s; }).join("&");
        //const cpdfCodes = searchOptions.filters.cpdfCodes.map(s => "cpdfCodes=" + s).join("&");
        var requestUrl = "";
        if (searchOptions.filters.isAdmin)
            requestUrl = baseApiUrl + "/profiles/admin-get-profiles?searchTerm=" + searchOptions.filters.searchTerm + "&pageSize=" + searchOptions.paging.itemsPerPage + "&currentPage=" + searchOptions.paging.currentPage + "&sortBy=" + searchOptions.paging.sortBy + "&isDesc=" + searchOptions.paging.isDesc;
        else
            requestUrl = baseApiUrl + "/profiles/get-profiles?searchTerm=" + searchOptions.filters.searchTerm + "&pageSize=" + searchOptions.paging.itemsPerPage + "&currentPage=" + searchOptions.paging.currentPage + "&sortBy=" + searchOptions.paging.sortBy + "&isDesc=" + searchOptions.paging.isDesc;
        if (agencies.length > 0) {
            requestUrl += "&" + agencies;
        }
        if (unions.length > 0) {
            requestUrl += "&" + unions;
        }
        if (busCodes.length > 0) {
            requestUrl += "&" + busCodes;
        }
        //if (cpdfCodes.length > 0) {
        //	requestUrl += "&" + cpdfCodes
        //}
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.createSearchQuery = function (searchOptions) {
        var agencies = searchOptions.filters.agencies.map(function (s) { return "agencies=" + s; }).join("&");
        var unions = searchOptions.filters.unions.map(function (s) { return "unions=" + s; }).join("&");
        //const cpdfCodes = searchOptions.filters.cpdfCodes.map(s => "cpdfCodes=" + s).join("&");
        var query = "searchTerm=" + searchOptions.filters.searchTerm + "&pageSize=" + searchOptions.paging.itemsPerPage + "&currentPage=" + searchOptions.paging.currentPage + "&sortBy=" + searchOptions.paging.sortBy + "&isDesc=" + searchOptions.paging.isDesc;
        if (agencies.length > 0) {
            query += "&" + agencies;
        }
        if (unions.length > 0) {
            query += "&" + unions;
        }
        //if (cpdfCodes.length > 0) {
        //	query += "&" + cpdfCodes
        //}
        return query;
    };
    ProfileService.prototype.getAgencies = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/agencies";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getAgencyObjects = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/agencies/GetObjects";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getUnions = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/unions";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getUnionObjects = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/unions/GetObjects";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getOlmrNumbers = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/olmr-numbers";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getCpdfCodes = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/cpdf-codes";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getCpdfCodeObjects = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/cpdf-codes/GetObjects";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getBusCodes = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/bus-codes";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getBusCodeObjects = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/bus-codes/GetObjects";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.getAffiliationObjects = function () {
        var _this = this;
        var requestUrl = baseApiUrl + "/affiliations/GetObjects";
        return this.http.get(requestUrl).pipe(catchError(function (httpError) {
            return _this.handleError(httpError);
        }));
    };
    ProfileService.prototype.isBusCodeInUse = function (busCode) {
        return this.http.get(baseApiUrl + "/bus-codes/BusCodeExists/" + busCode);
    };
    ProfileService.prototype.handleError = function (httpError) {
        var errorMessage = "An unknown error occurred while submitting the request.";
        if (httpError.error && httpError.error.message) {
            errorMessage = httpError.error.message;
        }
        return throwError(httpError);
    };
    ProfileService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProfileService_Factory() { return new ProfileService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.FormDataService)); }, token: ProfileService, providedIn: "root" });
    return ProfileService;
}());
export { ProfileService };
